document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('[data-menu-drawer]');
  var open = document.querySelector('.cs-menu-open');
  var close = document.querySelector('.cs-menu-close');

  if (drawer && open && close) {
    open.addEventListener('click', function () {
      drawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    close.addEventListener('click', function () {
      drawer.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  var hero = document.querySelector('[data-hero-carousel]');

  if (hero) {
    var hTrack = hero.querySelector('.cs-hero-track');
    var hSlides = hero.querySelectorAll('.cs-hero-slide');
    var hIndex = 0;

    if (hTrack && hSlides.length > 1) {
      setInterval(function () {
        hIndex = (hIndex + 1) % hSlides.length;
        hTrack.style.transform = 'translateX(-' + hIndex * 100 + '%)';
      }, 3800);
    }
  }

  document.querySelectorAll('[data-product-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.cs-product-track');
    var cards = carousel.querySelectorAll('.cs-product-card');
    var next = carousel.querySelector('.cs-product-next');
    var prev = carousel.querySelector('.cs-product-prev');
    var pause = carousel.querySelector('.cs-product-pause');

    if (!track || !cards.length) return;

    var index = 0;
    var playing = true;
    var timer;
    var speed = carousel.classList.contains('cs-product-carousel-2') ? 1700 : 2600;

    function perView() {
      return window.innerWidth < 769 ? 2 : 3;
    }

    function maxIndex() {
      return Math.max(0, cards.length - perView());
    }

    function update() {
      if (!cards.length) return;
      var card = cards[0];
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      var move = (card.offsetWidth + gap) * index;
      track.style.transform = 'translateX(-' + move + 'px)';
    }

    function goNext() {
      index = index >= maxIndex() ? 0 : index + 1;
      update();
    }

    function goPrev() {
      index = index <= 0 ? maxIndex() : index - 1;
      update();
    }

    function start() {
      stop();
      timer = setInterval(goNext, speed);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    if (next) {
      next.addEventListener('click', function () {
        goNext();
        if (playing) start();
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goPrev();
        if (playing) start();
      });
    }

    if (pause) {
      pause.addEventListener('click', function () {
        playing = !playing;
        pause.textContent = playing ? 'Ⅱ' : '▶';
        if (playing) {
          start();
        } else {
          stop();
        }
      });
    }

    window.addEventListener('resize', function () {
      index = Math.min(index, maxIndex());
      update();
    });

    start();
    update();
  });
});
document.querySelectorAll('.cs-menu-toggle').forEach(function(button) {
  button.addEventListener('click', function() {
    const drawer = document.querySelector('[data-menu-drawer]');

    if (drawer) {
      drawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  });
});
document.addEventListener('click', function(event) {
  var openButton = event.target.closest('.cs-menu-open');
  if (!openButton) return;

  var drawer = document.querySelector('[data-menu-drawer]');

  if (drawer) {
    drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
});